import H from 'react-highlight-words'

import type { MenuProps } from 'antd'

export const Highlighter = ({
  search,
  text,
}: {
  text: string
  search: string
}) => (
  <H
    searchWords={[search]}
    highlightClassName="text-orange-40"
    highlightStyle={{ padding: 0 }}
    autoEscape
    textToHighlight={text}
  />
)

type MenuItem = NonNullable<MenuProps['items']>[number]

export const filterMenuItemsRecursive = (
  items: NonNullable<MenuProps['items']>,
  searchConfig: string,
): NonNullable<MenuProps['items']> => {
  const searchTerm = searchConfig.toLowerCase()
  const isItemValid = (menuItem: MenuItem): boolean => {
    if (!menuItem) return false

    let parentValid = false
    let childrenValid = false
    if (typeof menuItem.key === 'string') {
      parentValid = menuItem.key.toLowerCase().includes(searchTerm)
    }
    if ('children' in menuItem && menuItem.children) {
      childrenValid = menuItem.children.some(isItemValid)
    }
    return parentValid || childrenValid
  }
  return items.filter((item) => item && isItemValid(item))
}
